import { render, staticRenderFns } from "./DevolucionBodega.vue?vue&type=template&id=4f683e1f&scoped=true"
import script from "./DevolucionBodega.vue?vue&type=script&lang=js"
export * from "./DevolucionBodega.vue?vue&type=script&lang=js"
import style0 from "./DevolucionBodega.vue?vue&type=style&index=0&id=4f683e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f683e1f",
  null
  
)

export default component.exports